class SpecialOffers extends HTMLElement {
  connectedCallback() {
    this._track = this.querySelector('[data-so-track]');
    this._dots  = this.querySelectorAll('[data-so-dot]');
    this._cards = this._track ? this._track.querySelectorAll('.so-card') : [];
    this._index = 0;

    if (this._cards.length > 1) {
      this._dots.forEach(dot => {
        dot.addEventListener('click', () => this._goTo(parseInt(dot.dataset.soDot, 10)));
      });

      // swipe support
      let startX = 0;
      this._track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
      this._track.addEventListener('touchend', e => {
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) this._goTo(this._index + (dx < 0 ? 1 : -1));
      });

      // auto-advance every 4 s if multiple offers
      this._timer = setInterval(() => this._goTo((this._index + 1) % this._cards.length), 4000);
      this.addEventListener('mouseenter', () => clearInterval(this._timer));
      this.addEventListener('mouseleave', () => {
        this._timer = setInterval(() => this._goTo((this._index + 1) % this._cards.length), 4000);
      });
    }

    // copy-to-clipboard
    this.querySelectorAll('[data-so-code]').forEach(btn => {
      btn.addEventListener('click', () => this._copyCode(btn));
    });
  }

  _goTo(i) {
    const count = this._cards.length;
    this._index = ((i % count) + count) % count;
    this._track.style.transform = `translateX(-${this._index * 100}%)`;
    this._dots.forEach(dot => {
      dot.classList.toggle('so-dot--active', parseInt(dot.dataset.soDot, 10) === this._index);
    });
  }

  _copyCode(btn) {
    const code = btn.dataset.soCode;
    navigator.clipboard.writeText(code).catch(() => {
      // fallback for older browsers
      const el = document.createElement('textarea');
      el.value = code;
      el.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      el.remove();
    });

    // visual feedback
    const original = btn.textContent;
    btn.textContent = 'COPIED!';
    btn.classList.add('copied');

    // auto-fill cart discount input if present on the page
    const cartInput = document.querySelector('[name="discount"]');
    if (cartInput) {
      cartInput.value = code;
      cartInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    setTimeout(() => {
      btn.textContent = original;
      btn.classList.remove('copied');
    }, 2000);
  }
}

customElements.define('special-offers', SpecialOffers);
